import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";
import { grey } from "@mui/material/colors";
import NumberTextField from "components/ReusableComponents/NumberTextField";
import { datatypes } from "data/globalData";
import { Tooltip } from "@mui/material";

const TextInputField = ({
	data,
	setData,
	column,
	width,
	required,
	type,
	sx,
	disabled,
	onChange,
	disableLabel,
	variant,
	error = false,
	...rest
}) => {
	return (
		<Stack sx={{ width }}>
			{!disableLabel && (
				<Tooltip title={column?.name + (required ? "*" : "")} placement="bottom-start" arrow>
					<InputLabel
						sx={{
							p: 1,
							overflow: "hidden",
						}}>
						{column?.name} {required && <span style={{ color: "red" }}>*</span>}
					</InputLabel>
				</Tooltip>
			)}
			{column?.data_type === datatypes.NUMBER.key || column?.data_type === datatypes.DECIMAL.key ? (
				<NumberTextField
					variant={variant ? variant : "outlined"}
					size="small"
					sx={sx}
					disableHelperText
					disabled={disabled}
					onChange={onChange}
					value={data && data[column.key] ? data[column.key] : 0}
					error={error}
					{...rest}
				/>
			) : column.data_type === datatypes.FILE.key ? (
				<TextField
					variant={variant ? variant : "outlined"}
					sx={sx}
					size="small"
					error={error}
					type={datatypes.FILE.htmlVar}
					onChange={onChange}
					disabled={disabled}
					placeholder={`Select ${column?.key}`}
					required={required ? required : false}
					fullWidth
					{...rest}
				/>
			) : (
				<TextField
					variant={variant ? variant : "outlined"}
					sx={sx}
					size="small"
					error={error}
					type={datatypes[column?.data_type] ? datatypes[column?.data_type].htmlVar : "text"}
					value={data && data[column.key] ? data[column.key] : ""}
					onChange={onChange}
					disabled={disabled}
					placeholder={`Enter ${column?.key}`}
					required={required ? required : false}
					fullWidth
					{...rest}
				/>
			)}
		</Stack>
	);
};

export default TextInputField;
